module.exports = __webpack_public_path__ + "static/media/o_64k.3673272b.mp3";